// extracted by mini-css-extract-plugin
export default {"textile":"Textile_textile__NUSOr","body":"Textile_body__qVvwZ","item":"Textile_item__9vNBV","image":"Textile_image__hz3Jz","button":"Textile_button__SGe-s"};